<template>
  <div class="container-fluid">
    <div class="card">
      <div class="row">
        <div class="col-md-3">
          <div v-if="organization" class="organization">
            <img :src="defaultThumb(organization.images)" :alt="organization.name">
          </div>
          <div class="filters">
            <div class="search">
              <input type="search" v-model="filters.search" placeholder="O que você procura?" class="form-control">
            </div>
            <br>
            <b-dropdown :text="filters.category || 'Filtrar por Categoria'" variant="outline-default" size="sm">
              <b-dropdown-item @click="filters.category = null">Todas as categorias</b-dropdown-item>
              <b-dropdown-item v-for="(category, index) in categorias_de_produtos" :key="index" @click="filters.category = category">{{category}}</b-dropdown-item>
            </b-dropdown>
            <br>
            <div class="checkbox-list">
              <h6>Filtrar por Tags</h6>
              <div>
                <div v-for="(tag, index) in tags" :key="index">
                  <label :class="{ active: filters.tags.includes(tag) }">
                    <input v-model="filters.tags" :value="tag" type="checkbox">
                    {{tag}}
                  </label>
                </div>
              </div>
            </div>
            <br>
            <DemandModal />
          </div>
        </div>
        <div class="col-md-9">
          <div class="content-header">
            <span v-if="filtered_offers" class="list-counter">
              <span v-if="filtered_offers.length > 1">{{filtered_offers.length}} ofertas encontradas</span>
              <span v-else-if="filtered_offers.length == 1">Uma oferta encontrada</span>
            </span>
            <div class="text-right pull-right">
              <b-dropdown :text="'Ordenar por ' + tipos_de_ordenacao[filters.sort]" variant="outline-default" size="sm">
                <b-dropdown-item v-for="(v, k) in tipos_de_ordenacao" :key="k" @click="filters.sort = k">{{v}}</b-dropdown-item>
              </b-dropdown>
            </div>
            <div class="clearfix" />
          </div>
          <loading :loading="isLoading" msg="Carregando ofertas" />
          <div class="row offers">
            <template v-for="(offer, index) in filtered_offers">
              <div v-if="showAll || index < 12" class="col-lg-4 col-md-6" :key="index">
                <div class="card">
                  <router-link :to="'/oferta/'+offer._id" class="card-img">
                    <product-image :product="offer.product" :product_variation="offer.product_variation" css_class="card-img-top" />
                  </router-link>
                  <div class="card-body">
                    <router-link :to="'/oferta/'+offer._id">
                      <h2 class="card-title">{{offer.product_variation.name}}</h2>
                    </router-link>
                  </div>
                  <div class="card-footer">
                    <AddToCart :offer="offer" />
                  </div>
                </div>
                <!-- end card -->
              </div>
            </template>
          </div>
          <div v-if="filtered_offers && filtered_offers.length >= 12 && !showAll" class="text-center" @click="showAll = true">
            <b-button variant="primary">
              + ver mais
            </b-button>
          </div>
          <br>
          <hr>
          <div v-if="filtered_offers && filtered_offers.length == 0" class="alert alert-warning">
            Nenhuma oferta encontrada.
          </div>
          <div>
            <br>
            <DemandModal />
            <br>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import slugify from 'slugify'
import Loading from '@/components/Loading'
import ProductImage from '@/components/ProductImage'
import AddToCart from '@/components/AddToCart'
import DemandModal from '@/components/DemandModal'
import categorias_de_produtos from '@/data/categorias-de-produtos.json'
import tipos_de_ordenacao from '@/data/tipos-de-ordenacao.json'

export default {

  name: 'Shop',

  data() {
    return {
      categorias_de_produtos,
      tipos_de_ordenacao,
      organization: null,
      qtds: [],
      showAll: false,
      filters: {
        tags: [],
        search: '',
        category: '',
        sort: 'most_recent'
      },
      offers: null,
      filtered_offers: null,
      tags: [],
    }
  },

  created() {
    if (this.$route.params.organization_id) {
      axios.get('shop/organizations/'+this.$route.params.organization_id).then(response => {
        this.organization = response.data
        this.list()
        if (!this.organization) {
          this.notify("Rede não encontrada", "error")
        }
      }).catch(this.showError)
    } else {
      this.list()
    }
  },

  methods: {
    async list() {
      this.isLoading = true
      var params = {}
      if (this.organization) {
        params = { params: { organization: this.organization._id } }
      }
      axios.get('shop/offers', params).then(response => {
        this.offers = response.data
        this.applyFilters()
      }).catch(this.showError)

      axios.get('shop/tags', params).then(response => {
        this.tags = response.data
      }).catch(this.showError)

    },
    applyFilters() {
      this.filtered_offers = this.offers
      if (this.filters.search) {
        this.filtered_offers = this.filtered_offers.filter(offer => {
          var name = slugify(offer.product_variation.name).toLowerCase()
          var search = slugify(this.filters.search).toLowerCase()
          return name.search(search) >= 0
        })
      }

      if (this.filters.tags && this.filters.tags.length) {
        this.filters.tags.forEach(tag => {
          this.filtered_offers = this.filtered_offers.filter(offer => {
            return offer.product_variation.tags.find(offer_tag => {
              return offer_tag.text == tag
            })
          })
        })
      }

      if (this.filters.category && this.filters.category) {
        this.filtered_offers = this.filtered_offers.filter(offer => {
          if (offer.product_variation.product.categories) {
            return offer.product_variation.product.categories.find(category => {
              return category == this.filters.category
            })
          }
        })
      }

      switch (this.filters.sort) {
        case 'most_recent':
          this.filtered_offers = this.filtered_offers.sort((a, b) => {
            return new Date(b.createdAt) - new Date(a.createdAt)
          })
          break
        case 'best_sellers':
          this.filtered_offers = this.filtered_offers.sort((a, b) => {
            return b.qtd_ordered - a.qtd_ordered
          })
          break
        case 'alphabetical_order':
          this.filtered_offers = this.filtered_offers.sort((a, b) => {
            return a.product_variation.name.localeCompare(b.product_variation.name)
          })
          break
      }

      this.qtds = []
      this.filtered_offers.forEach(() => {
        this.qtds.push(1)
      })

      this.isLoading = false
    },
    clearFilters() {
      this.filters = {
        search: '',
        tags: []
      }
      location.href = "/"
    }
  },
  watch: {
    'filters.search': function() {
      this.applyFilters()
    },
    'filters.category': function() {
      this.applyFilters()
    },
    'filters.tags': function() {
      this.applyFilters()
    },
    'filters.sort': function() {
      this.applyFilters()
    }
  },
  components: {
    Loading,
    ProductImage,
    AddToCart,
    DemandModal
  }
}
</script>
<style lang="sass" scoped>
  .organization
    text-align: center
    img
      max-width: 100%
  .search
    input
      border: none
      color: #215F60
      border-bottom: 1px solid #215F60
      border-radius: 0
      padding: 10px 0
      font-size: 16px
      font-weight: bold
      background-image: url("../assets/img/search.svg")
      background-repeat: no-repeat
      background-position: 100%
      background-size: 20px
      padding-right: 22px
      margin-bottom: 10px
      &::placeholder
        color: #215F60
  .offers
    .card
      margin-bottom: 30px
      border-radius: 15px
      .card-body
        padding-bottom: 0
        h2
          margin-bottom: 0
          font-size: 16px
          font-weight: 100
          color: #505050
      .card-footer
        background-color: transparent
        border-top: none
</style>
